import React from 'react';
import { Switch as AriaSwitch, type SwitchProps as AriaSwitchProps, composeRenderProps } from 'react-aria-components';
import { cn, focusRing } from './utils';

export interface SwitchProps extends Omit<AriaSwitchProps, 'children'> {
	children: React.ReactNode;
}

export function Switch({ children, ...props }: SwitchProps) {
	return (
		<AriaSwitch
			{...props}
			className={composeRenderProps(props.className, className =>
				cn(
					'group flex items-center gap-2 text-sm text-gray-800 transition disabled:text-gray-300 forced-colors:disabled:text-[GrayText]',
					className
				)
			)}
		>
			{renderProps => (
				<>
					<div
						className={cn(
							'flex h-4 w-7 shrink-0 cursor-default items-center rounded-full border border-transparent px-px shadow-inner transition duration-200 ease-in-out',
							focusRing(renderProps),
							renderProps.isSelected
								? 'group-pressed:bg-gray-800 bg-gray-700 forced-colors:!bg-[Highlight]'
								: 'group-pressed:bg-gray-500 bg-gray-400',
							renderProps.isDisabled && 'forced-colors:group-selected:!bg-[GrayText] bg-gray-200 forced-colors:border-[GrayText]'
						)}
					>
						<span
							className={cn(
								'h-3 w-3 transform rounded-full bg-white shadow outline outline-1 -outline-offset-1 outline-transparent transition duration-200 ease-in-out',
								renderProps.isSelected ? 'translate-x-[100%]' : 'translate-x-0',
								renderProps.isDisabled && 'forced-colors:outline-[GrayText]'
							)}
						/>
					</div>
					{children}
				</>
			)}
		</AriaSwitch>
	);
}
